import axios from "@/plugins/axios";

let url = "/api/v1/nshop/orders";

/** @typedef {import('../../../../store/nshop').NshopOrder} $NshopOrder */

export const orders = {
    /**
     * 주문 생성 — ORDER_PREP(결제준비)로 생성된다.
     * @param {Partial<$NshopOrder>} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },

    /**
     * 결제 시작(바인딩) — ORDER_PREP → ORDER_INIT.
     * 결제 전 주문에 실결제정보를 바인딩하는 수단(가상계좌 등)에서 사용한다.
     * (오픈뱅킹은 /api/plugins/open-bank/request → 결제창 흐름을 타므로 이 API 를 쓰지 않는다)
     * @param {{ _id: string }} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    init({ _id }) {
        return axios.post(`${url}/${_id}/init`).then((result) => result.data);
    },
};

export default orders;
